import { all } from 'redux-saga/effects'
import { analyticsSaga } from './analytics'
import { catsSaga } from './cats'
import { gridsSaga } from './grids'
import { mediaSaga } from './media'
import { menusSagas } from './menus'
import { pagesSaga } from './pages'
import { postsSaga } from './posts'
import { slugsSaga } from './slugs'
import { customSagas } from '../custom/sagas'

export default function* rootSaga() {
  yield all([
    ...analyticsSaga,
    ...catsSaga,
    ...gridsSaga,
    ...mediaSaga,
    ...menusSagas,
    ...pagesSaga,
    ...postsSaga,
    ...slugsSaga,
    ...customSagas
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js